module.exports = __webpack_public_path__ + "static/img/nurse-portrait.62db82d8.png";